module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Gustave Palombo-Houston - Designer', // Navigation and Site Title
  titleAlt: 'Gustave Palombo-Houston', // Title for JSONLD,
  description: 'Gustave Palombo-Houston, UI Design, Branding, Fashion',
  headline: "'Gustave Palombo-Houston, UI Design, Branding, Fashion", // Headline for schema.org JSONLD
  url: 'https://gusshouston.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  logo: '/logos/logo-1024.png', // Used for SEO
  ogLanguage: 'en_US', // Facebook Language

  // JSONLD / Manifest
  favicon: 'src/favicon.png', // Used for manifest favicon generation
  shortName: 'Gustave', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Gustave', // Author for schemaORGJSONLD
  themeColor: '#3D63AE',
  backgroundColor: '#EBEDF2',

  facebook: 'guss-houston', // Facebook Site Name
  googleAnalyticsID: '',

  skipNavId: 'reach-skip-nav', // ID for the "Skip to content" a11y feature
}
